
import React from "react";
import { component_tool, framework_tool, utils_tool } from '@/tool';
import * as local_urls from '../../../../constants/constants_url';

const urls = global && global.constants && global.constants.urls ? global.constants.urls : local_urls;

let { WizModal,WizButton,WizDataTable} = component_tool;

const columns = () => {
    return [
      {
        name: "id",
        formItem: {
          type: "hidden"
        }
      },
      {
        title: "编码",
        name: "methodCode",
        dataIndex: "methodCode",
        tableItem: {
          width: 150
        }
      },
        {
          title: "标题",
          name: "title",
          dataIndex: "title",
          searchItem: {},
          tableItem: {
            width: 150
          }
        },
        {
          title: "简介",
          name: "intro",
          dataIndex: "intro",
          tableItem: {
            width: 200
          }
        },
        {
          title: "状态",
          name: "state",
          dataIndex: "state",
          tableItem: {
            width: 100
          },
          dict: [
            { code: 1, codeName: "启用" },
            { code: 0, codeName: "禁用" }
          ],
          searchItem: {
            type: "select"
          },
          formItem: {
            type: "select"
          }
        },
      ];
  };
  
  const tableApi = (api = {}) => {
    return {
      path: 'workflowAudit/auditMethodListByPage',
      ...api
    }
  };
  
  const workflowAuditMethod = (self, api) => {
    return {
      type: 'diy',
      initialValue: [],
      rowkey: 'id',
      rowName: 'title',
      columns: columns(),
      tableApi: tableApi(api)
    }
  };
  
  export default workflowAuditMethod
  